// extracted by mini-css-extract-plugin
module.exports = {"ContactData":"ContactData__ContactData__2rmgR","Pagination":"ContactData__Pagination__3Lh3S"};